import { useState } from "react";
import { useGlobalContext } from "../../../../../../Context/Context";
import Button from "../../../../../Custom/Button/Button";
import axios from "axios";
import KontaktiModal from "./KontaktiModal";

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold" },
};

function ButtonsEdit({
  setCurrentState,
  newData,
  data,
  setData,
  setNewData,
  zaposleniAll,
  onRefresh,
}) {
  const { dictionary, baseUrl } = useGlobalContext();
  const [isOpenKontakti, setIsOpenKontakti] = useState(false);

  const handleSacuvaj = async () => {
    try {
      const stavkeZaSlanje = newData.stavke.map((s) => ({
        id: s.id,
        kolicina_trenutna: s.kolicina_trenutna,
      }));

      const { data: res } = await axios.post(
        `${baseUrl}/spp/update_stavke.php`,
        { stavke: stavkeZaSlanje },
      );
      if (res.status === 200) {
        setData(newData);
        setCurrentState("");
      } else alert("Greška pri čuvanju.");
    } catch (e) {
      console.error(e);
      alert("Greška na serveru.");
    }
  };

  const handleOdustani = () => {
    setNewData(data);
    setCurrentState("");
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <div onClick={() => setIsOpenKontakti(true)}>
          <Button activation={true} style={styles.button}>
            {dictionary["izmeniKontaktPodatke"]}
          </Button>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={handleOdustani}>
            <Button activation={true} style={styles.button}>
              {dictionary["odustani"]}
            </Button>
          </div>
          <div onClick={handleSacuvaj}>
            <Button activation={true} style={styles.button}>
              {dictionary["sacuvaj"]}
            </Button>
          </div>
        </div>
      </div>

      {isOpenKontakti && (
        <KontaktiModal
          sredstvoId={data.id}
          data={data}
          zaposleniAll={zaposleniAll}
          onSaved={onRefresh}
          onClose={() => setIsOpenKontakti(false)}
        />
      )}
    </>
  );
}

export default ButtonsEdit;
